<template>
    <div v-if="visible" class="fw-popup">
        <div @click="visible = false" class="close-btn">
            <i class="far fa-3x fa-times-circle"></i>
        </div>
        <MapPopup :device="device" :router="$router" />
    </div>
</template>

<script>

    import EventBus from "./EventBus";
    import MapPopup from "./MapPopup";

    export default {
        name: "FwMapPopup",
        components: {
            MapPopup
        },
        data() {
            return {
                visible: false,
                device: null
            }
        },
        mounted() {
            EventBus.$on("MARKER_ONCLICK", ({device, marker}) => {
                this.device = device;
                this.visible = true;
            })
        }
    }
</script>

<style lang="less" scoped>
    .fw-popup {
        display: flex;
        justify-content: center;
        padding: 5rem 1rem 1rem;
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: #ffffff;
        z-index: 1000;

        .close-btn{
            position: absolute;
            top: 1rem;
            right: 1rem;
        }
    }
</style>